const STORAGE_PREFIX = 'lastSelectedClientId';

export function lastSelectedClientStorageKey(userId) {
  return userId != null ? `${STORAGE_PREFIX}:${userId}` : STORAGE_PREFIX;
}

export function parseClientIdParam(value) {
  if (value == null || value === '') return null;
  const parsed = parseInt(String(value), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function readLastSelectedClientId(userId) {
  try {
    return parseClientIdParam(
      localStorage.getItem(lastSelectedClientStorageKey(userId)),
    );
  } catch {
    return null;
  }
}

export function writeLastSelectedClientId(userId, clientId) {
  try {
    const key = lastSelectedClientStorageKey(userId);
    const parsed = parseClientIdParam(clientId);
    if (parsed == null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, String(parsed));
    }
  } catch {
    // Ignore quota / private-mode errors.
  }
}

/** URL deep link wins, then persisted id, then first active client. */
export function resolveScopedClientId({
  clients,
  urlClientId,
  persistedClientId,
}) {
  const rows = Array.isArray(clients) ? clients : [];
  const validIds = new Set(rows.map((c) => c.id));

  if (urlClientId != null && validIds.has(urlClientId)) {
    return urlClientId;
  }
  if (persistedClientId != null && validIds.has(persistedClientId)) {
    return persistedClientId;
  }
  return rows[0]?.id ?? null;
}
